module.exports = __webpack_public_path__ + "img/mock-small-page.232117ae.png";